import { ERROR_MESSAGE, NOTIFICATION_SET } from './actionTypes';
import makeActionCreator from '../../../utils/makeActionCreator';

export const error = makeActionCreator(ERROR_MESSAGE, 'message');

export const setNotification = makeActionCreator(NOTIFICATION_SET, 'message', 'status');